import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '3.7fr 8.3fr 6.2fr 7.3fr 1.5fr',
    [theme.breakpoints.up(1440)]: {
      gridTemplateColumns: '4fr 8fr 6fr 8fr 1fr'
    },
    [theme.breakpoints.between(960, 1200)]: {
      gridTemplateColumns: '3.7fr 7.1fr 7.5fr 6fr 1.5fr'
    },
    padding: '0 0 0 12px',
    marginTop: 4,
    alignItems: 'center',
    borderRadius: 12,
    marginBottom: 4,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '4fr 3fr',
      paddingBottom: 8,
      paddingTop: 8,
      paddingRight: 7
    }
  }
}))
export default useStyles
